<template>
  <div class="page-footer footer-c-height" align="center">
    <div class="page-footer-inner">
      <div class="footer-links">
        <label style="font-weight: 700;">Useful Links:</label> <a href="http://www.awesome.dev" target="_blank">Main
        B1G1 Site</a> | <a href="#" target="_blank">WC Login</a> | <a href="#" target="_blank">WordPress Login</a> |
        <a href="#" target="_blank">Google Analytics</a>
      </div>
      <div>Copyright &copy; 2007 -
        {{getCurrentYear()}} Buy1Give1 Pte Ltd/B1G1 Giving Inc (Singapore)
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  methods: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Footer.vue